export interface Category {
  slug: string;
  name: string;
  subtitle: string;
  description: string;
  color: string;
  image: string;
}

export const categories: Category[] = [
  {
    slug: "yuzhi",
    name: "治愈番",
    subtitle: "点开就暖",
    description:
      "温柔的画风、平淡又动人的日常故事，让疲惫的心一点点被治愈。适合睡前、通勤、工作间隙慢慢看。",
    color: "primary",
    image:
      "https://readdy.ai/api/search-image?query=soft%20warm%20illustration%20of%20a%20kitten%20hugging%20a%20steaming%20tea%20cup%20on%20a%20cozy%20windowsill%2C%20gentle%20sunlight%2C%20pastel%20cream%20and%20peach%20tones%2C%20cute%20storybook%20style%2C%20healing%20atmosphere%2C%20flat%20vector%20art&width=800&height=600&seq=cat-yuzhi&orientation=landscape",
  },
  {
    slug: "gaoxiao",
    name: "搞笑萌漫",
    subtitle: "笑到打滚",
    description:
      "无厘头的脑洞、毛绒绒的角色、一集一个笑点的轻喜剧，是碎片时间最解压的快乐源泉。",
    color: "accent",
    image:
      "https://readdy.ai/api/search-image?query=playful%20funny%20illustration%20of%20three%20chubby%20cute%20kittens%20tumbling%20over%20each%20other%20with%20huge%20smiles%2C%20confetti%20and%20bubbles%2C%20bright%20soft%20pink%20and%20cream%20palette%2C%20comic%20storybook%20vector%20art&width=800&height=600&seq=cat-gaoxiao&orientation=landscape",
  },
  {
    slug: "ruanmeng",
    name: "软萌画风",
    subtitle: "萌到融化",
    description:
      "圆润的线条、细腻的配色、可爱到犯规的角色设计，专为颜控与萌系爱好者准备的高颜值作品合集。",
    color: "secondary",
    image:
      "https://readdy.ai/api/search-image?query=cute%20adorable%20illustration%20of%20a%20round%20fluffy%20cat%20face%20with%20big%20sparkling%20eyes%2C%20soft%20clouds%20and%20stars%20background%2C%20mint%20and%20cream%20pastel%20palette%2C%20kawaii%20korean%20style%20vector%20art&width=800&height=600&seq=cat-ruanmeng&orientation=landscape",
  },
  {
    slug: "wenxin",
    name: "温馨向轻喜剧",
    subtitle: "暖暖的日常",
    description:
      "没有刀、没有虐，只有邻里、朋友和家人的温暖瞬间。细腻又好笑，看完会想给身边的人一个拥抱。",
    color: "primary",
    image:
      "https://readdy.ai/api/search-image?query=heartwarming%20illustration%20of%20a%20cat%20and%20dog%20sitting%20together%20sharing%20a%20blanket%20and%20bowl%20of%20rice%20by%20a%20warm%20lamp%2C%20cozy%20home%20scene%2C%20soft%20peach%20and%20cream%20tones%2C%20gentle%20light%20comedy%20storybook%20vector%20art&width=800&height=600&seq=cat-wenxin&orientation=landscape",
  },
];

export const categoryMap: Record<string, Category> = categories.reduce(
  (acc, c) => {
    acc[c.slug] = c;
    return acc;
  },
  {} as Record<string, Category>
);